import { Pipe, PipeTransform } from '@angular/core';
import {DecimalPipe} from '@angular/common';

@Pipe({
    name: 'taNumber',
    standalone: true
})
export class TaNumberPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) { }

  transform(value: any, args?: any): any {
    if (value != null && value.toString().length > 0) {
      let sVal = value.toString().toLowerCase().replace(/,/g, '');
      const lastChar = sVal.substr(sVal.length - 1);
      const charAry = ['', 'k', 'm', 'b', 't'];
      const charIndex = charAry.indexOf(lastChar);

      if (charIndex > 0) {
        sVal = sVal.substr(0, sVal.length - 1);
      }

      if (sVal.match(/^-?[0-9e]+(\.[0-9e]*){0,1}$/g)) {
        let num = Number(sVal);
        if (isNaN(num)) {
          value = null;
        } else {
          if (charIndex > 0) {
            num = num * Math.pow(1000, charIndex);
          }
          value = num;
        }
      } else {
        value = null;
      }
    }
    return this.decimalPipe.transform(value, args);
  }

}


